module.exports = __webpack_public_path__ + "static/media/inner.cee0bdac.png";